import React from 'react'
import Introduction from '../../components/introduction/Introduction'
import Projects from '../../components/projects/Projects'
import About from '../../components/about/About'
import Blogs from '../../components/blogs/Blogs'
import Posts from '../../components/posts/Posts'
import Experience from '../../components/experience/Experience'
import Tools from '../../components/tools/Tools'
import Navbar from '../../components/navbar/Navbar'
// import Youtube from '../../components/youtube/Youtube'

const LandingPage = () => {
  return (
    <div>
        <Navbar page='landing-page'/>
        <Introduction />
        <About />
        <Experience />
        <Tools />
        <Projects />
        <Blogs />
        {/* <Youtube /> */}
        <Posts />
    </div>
  )
}

export default LandingPage